import { AfterContentChecked, ContentChild, ContentChildren, Directive, HostBinding, QueryList } from '@angular/core';
import { FormControl, FormControlName } from '@angular/forms';
import { ValidationMessageComponent } from '@shared/components/validation-message/validation-message.component';

@Directive({
    selector: '[gccValidation]',
    standalone: false
})
export class ValidationDirective implements AfterContentChecked {
  @ContentChild(FormControlName) public control: FormControlName;
  @ContentChildren(ValidationMessageComponent, { descendants: true }) public messages: QueryList<
    ValidationMessageComponent
  >;
  @HostBinding('class.gcc-invalid')
  get invalid() {
    if (!this.control || !this.control.control.errors) {
      return false;
    }
    const control: FormControl = this.control.control;
    const errors = Object.keys(control.errors);
    if (errors.filter(e => e !== 'required').length) {
      return true;
    } else if (errors.length) {
      return control.dirty;
    }
    return false;
  }

  constructor() {}

  public ngAfterContentChecked() {
    const control: FormControl = this.control.control;
    this.messages.forEach(message => {
      message.hidden = true;
      if (control.errors && control.errors[message.for]) {
        if (message.for !== 'required' || (message.for === 'required' && control.dirty)) {
          message.hidden = false;
        }
      }
    });
  }
}
